<script>
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Alert
    } from 'sveltestrap';
  import { onMount } from 'svelte';
  import { api_url, path_url } from "../ConfigService.js";
  import { Textfield } from 'svelte-mui';

	let email;
	let message;
	let error;
	let currentDomain = window.location.origin;

	const validateEmail = (email) => {
	  const regex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
	  return regex.test(email);
	};

	const sendEmail = async () => {
	  if (!validateEmail(email)) {
	    error='Chybný e-mail!';
	    return;
	  }

	  const response = await fetch($api_url+'sendEmail.php', {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json',
	    },
	    body: JSON.stringify({
	      email: email,
	      message: currentDomain+'/photos/'+orderno,
	    }),
	  });

	  const data = await response.json();
	  if (data.success) {
	    error=false;
	    alert('E-mail byl úspěšně odeslán!');
	    open=false;
	  } else {
	  	error='Chyba při odesílání e-mailu.';
	  	if(data.message) { error=data.message; }
	  }
	};

	  async function downloadQR(qrUrl) {
	    const response = await fetch(qrUrl);
	    const blob = await response.blob();
	    const blobUrl = URL.createObjectURL(blob);

	    const link = document.createElement('a');
	    link.href = blobUrl;
	    link.download = "fotonapapir_cz-qr.png";
	    document.body.appendChild(link);
	    link.click();
	    document.body.removeChild(link);
	    URL.revokeObjectURL(blobUrl);
	  }
  
  export let orderno;
  export let open=false;
  const toggle = () => (open = !open);
 

</script>

<Modal isOpen={open} {toggle} size="lg">
   <ModalHeader {toggle}>Odeslání odkazu e-mailem</ModalHeader>
   <ModalBody>
   	<h3>Můžete si uložit QR kód</h3>
            <center>
            	<img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data={encodeURIComponent(currentDomain+'/photos/'+orderno+'/')}" />
            	<div class="pt-2"><a href="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data={encodeURIComponent(currentDomain+'/photos/'+orderno+'/')}" on:click|preventDefault="{()=>downloadQR('https://api.qrserver.com/v1/create-qr-code/?size=200x200&data='+encodeURIComponent(currentDomain+'/photos/'+orderno+'/'))}" download>uložit QR</a></div>
            </center>
        <br /><br />
        <h3>Nebo zaslat na e-mail</h3> 
        <Textfield type="text" label="Zadejte e-mail k odeslání odkazu" name="email" bind:value={email} required class="codeInput" />
	<Button color="{email ? "primary" : "secondary"}" outlined on:click={sendEmail}>Odeslat na e-mail</Button>
        {#if error}
        	<br /><br />
        	<div class="warning"><br />{error}</div>
        {/if}
        <br /><br /><br />
   </ModalBody>
</Modal>

<style>
  .warning { color:darkred; font-size:20px; }
</style>

